import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from 'react';
import { IconButton } from '@material-ui/core';
import { Controller } from 'react-hook-form';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import { useTheme, Box, Button } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import { useIntl } from 'umi';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import ArchiveIcon from '@material-ui/icons/Archive';
import FormHelperText from '@material-ui/core/FormHelperText';
import CloseIcon from '@material-ui/icons/Close';
import Loading from '@/components/loading_ml/Loading';
import UploadFileMLStyled from './UploadFileMLStyled';
import request from '@/utils/request';
import { downloadCsv, download } from '@/utils/downloadUtil';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import ButtonTip from '@/components/buttonTip/ButtonTip';

const UploadFileML = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  // 批量导入dialog状态
  const [batchImportOpen, setBatchImportOpen] = useState(false);
  const [importFetchStatus, setImportFetchStatus] = useState(false);
  const [type, setType] = useState(2);
  const csvRef = useRef();
  const excelRef = useRef();
  const {
    fileInfo,
    setFileInfo,
    status,
    control,
    errors,
    isDialog = false,
  } = props;
  //关于文件信息
  useEffect(() => {
    if (fileInfo?.fileName) {
      setFileName(fileInfo.fileName);
    }
  }, [fileInfo]);
  //关于编辑状态
  useEffect(() => {
    if (status === 'detail') {
      setDisabled(true);
    }
  }, [status]);

  const handleDeleteFile = () => {
    if (status !== 'detail') {
      setFileInfo(undefined);
      setFileName();
      setDisabled(false);
    }
  };
  const [fileName, setFileName] = useState('');
  const handleDownLoadClick = () => {
    if (status !== 'detail') {
      if (fileInfo.filePath.indexOf('.csv')) {
        downloadCsv(
          fileInfo.downloadUrl,
          {},
          fileInfo.fileName,
          'text/csv;charset=utf-8;',
        );
      } else {
        download(fileInfo.downloadUrl, {}, fileInfo.fileName);
      }
    }
  };
  const theme = useTheme();
  const [disabled, setDisabled] = useState(false);
  const uploadFile = (formData, fileNames) => {
    setImportFetchStatus(1);
    request('/common/upload', {
      method: 'POST',
      data: formData,
    })
      .then((res) => {
        if (res.code === 0) {
          setBatchImportOpen(false);
          setFileName(fileNames);
          setDisabled(true);
          setFileInfo({
            filePath: res.data.url,
            downloadUrl: res.data.downloadUrl,
            fileName: fileNames,
            code: res.code,
          });
        } else {
          window.message.toast({
            type: 'error',
            message: res.message,
            title: '失败',
          });
        }
        setImportFetchStatus();
        if (csvRef && csvRef.current) {
          csvRef.current.value = '';
        }
        if (excelRef && excelRef.current) {
          excelRef.current.value = '';
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  //批量导入的内容部分
  const batchImportContent = () => {
    return (
      <Loading loading={importFetchStatus}>
        <Box gap="16px 0" display="flex" flexDirection="column">
          <Box sx={{ color: '#212121', fontSize: '16px' }}>上传Excel文件</Box>
          <Box display="flex" alignItems="center">
            <Box
              sx={{
                width: '32px',
                height: '32px',
                fontSize: '16px',
                color: '#ffffff',
                background: theme.palette.primary.main,
                borderRadius: '50%',
                textAlign: 'center',
                lineHeight: '32px',
                marginRight: '10px',
              }}
            >
              1
            </Box>
            <Box sx={{ fontSize: '16px', color: '#212121' }}>
              根据标准模板格式填写信息，前往
              <span
                style={{
                  color: theme.palette.primary.main,
                  cursor: 'pointer',
                }}
                onClick={handleDownloadExcelTemplate}
              >
                下载模板{'>'}
                {'>'}
              </span>
            </Box>
          </Box>
          <Box display="flex" alignItems="center">
            <Box
              sx={{
                width: '32px',
                height: '32px',
                fontSize: '16px',
                color: '#ffffff',
                background: theme.palette.primary.main,
                borderRadius: '50%',
                textAlign: 'center',
                lineHeight: '32px',
                marginRight: '10px',
              }}
            >
              2
            </Box>
            <Box sx={{ fontSize: '16px', color: '#212121' }}>
              点击上传文件按钮
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              gap: '0 32px',
              width: '100%',
              marginBottom: '36px',
            }}
          >
            <Button
              sx={{ width: '140px!important', height: '36px' }}
              variant="contained"
              onClick={() => {
                setType(1);
                setTimeout(() => handleUploadExcel(1), 100);
              }}
            >
              上传Excel文件
            </Button>
          </Box>
        </Box>
        <hr style={{ margin: '8px 0px 22px' }} />
        <Box gap="16px 0" display="flex" flexDirection="column">
          <Box sx={{ color: '#212121', fontSize: '16px' }}>上传CSV文件</Box>
          <Box display="flex" alignItems="center">
            <Box
              sx={{
                width: '32px',
                height: '32px',
                fontSize: '16px',
                color: '#ffffff',
                background: theme.palette.primary.main,
                borderRadius: '50%',
                textAlign: 'center',
                lineHeight: '32px',
                marginRight: '10px',
              }}
            >
              1
            </Box>
            <Box sx={{ fontSize: '16px', color: '#212121' }}>
              格式：从第一行开始，每行一个手机号，文件大小不超过 2M
            </Box>
          </Box>
          <Box display="flex" alignItems="center">
            <Box
              sx={{
                width: '32px',
                height: '32px',
                fontSize: '16px',
                color: '#ffffff',
                background: theme.palette.primary.main,
                borderRadius: '50%',
                textAlign: 'center',
                lineHeight: '32px',
                marginRight: '10px',
              }}
            >
              2
            </Box>
            <Box sx={{ fontSize: '16px', color: '#212121' }}>
              点击上传文件按钮
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              gap: '0 32px',
              width: '100%',
              marginBottom: '36px',
            }}
          >
            <Button
              sx={{ width: '140px!important' }}
              variant="contained"
              onClick={() => {
                setType(2);
                setTimeout(() => handleUploadExcel(2), 100);
              }}
            >
              上传CSV文件
            </Button>
          </Box>
        </Box>
      </Loading>
    );
  };
  //批量导入底部按钮自定义
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          gap: '0 32px',
          width: '100%',
        }}
      >
        <Button
          sx={{ width: '140px!important' }}
          variant="contained"
          onClick={() => {
            setType(2);
            setTimeout(() => handleUploadExcel(2), 100);
          }}
        >
          上传CSV文件
        </Button>
      </Box>
    );
    return { buttonNode, isShow: false };
  };
  //下载模板
  const handleDownloadExcelTemplate = () => {
    download('/common/importMobileTemplate');
  };
  //打开关闭批量导入dialog
  const onCloseBatchImportDialog = () => {
    setBatchImportOpen(false);
  };
  const handleUploadExcel = useCallback(
    (v) => {
      if (v === 2 && csvRef.current) {
        csvRef.current.click();
        return;
      }
      if (v === 1 && excelRef.current) {
        excelRef.current.click();
        return;
      }
    },
    [type],
  );

  const fileNameSplit = useMemo(() => {
    if (fileName) {
      const lastIndexOfNum = fileName.lastIndexOf('.');
      const name = fileName.substring(0, lastIndexOfNum);
      const font = fileName.substring(lastIndexOfNum + 1);
      return { name, font };
    }
    return null;
  }, [fileName]);
  return (
    <UploadFileMLStyled theme={theme} status={status}>
      <div className="button-wrapper">
        {fileName ? (
          <Fab
            variant="extended"
            size="small"
            color="primary"
            aria-label="add"
            onClick={handleDownLoadClick}
            // className={classes.margin}
          >
            <ArchiveIcon sx={{ width: '24px', height: '24px' }} />
            {formatMessage({ id: 'comm.action.btn.21' })}
          </Fab>
        ) : (
          <Fab
            variant="extended"
            size="small"
            color="primary"
            aria-label="add"
            // disabled={disabled}
            // className={classes.margin}
            onClick={() => {
              if (isDialog) {
                return setBatchImportOpen(true);
              }
              csvRef.current.click();
            }}
          >
            <CreateNewFolderIcon sx={{ width: '24px', height: '24px' }} />
            {formatMessage({ id: 'comm.action.btn.20' })}
          </Fab>
        )}
        {isDialog ? (
          ''
        ) : (
          <span className="text">
            【请使用后缀为"csv"的文档；从第一行开始，一行一个手机号，文件大小不超过
            2M】
          </span>
        )}

        {!fileInfo && (
          <>
            <Controller
              render={(rp) => {
                return (
                  <input
                    key="2"
                    ref={type === 2 ? csvRef : excelRef}
                    className="input"
                    name="file"
                    disabled={disabled}
                    type="file"
                    id="inputFile"
                    rules={{
                      required: true,
                    }}
                    accept={
                      type === 2
                        ? '.csv'
                        : ('application/vnd.ms-excel.xlsx',
                          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                    }
                    label="上传文件"
                    onChange={(e) => {
                      const fileList = e.target.files;
                      let file = fileList;
                      let formData = new FormData();
                      const fileNames = file[0].name;
                      if (file) {
                        formData.append('file', file[0]);
                        formData.append('isFixedName', false);
                        formData.append('isPublic', false);
                        formData.append('bucket', 'ACTIVITY_MOBILE_FILE');
                        uploadFile(formData, fileNames);
                      }
                      return rp.onChange(e);
                    }}
                  />
                );
              }}
              name="file"
              type="file"
              label="导入文件"
              control={control}
              // defaultValue=""
              rules={{ required: true }}
            />
            <FormHelperText error={Boolean(errors.file)}>
              {Boolean(errors?.file?.type === 'required') && '请导入文件'}
            </FormHelperText>
          </>
        )}
      </div>
      <div className="file-name">
        <div className="row">
          <span className="name">
            {formatMessage({ id: 'marketing.people.mpnumber.c01.lbl01' })}
          </span>
          <span className="font">
            {formatMessage({ id: 'marketing.people.mpnumber.c01.lbl02' })}
          </span>
          <span className="action">
            {formatMessage({ id: 'marketing.people.mpnumber.c01.lbl03' })}
          </span>
        </div>
        <div className="row second-row">
          <span className="name">{fileNameSplit?.name}</span>
          <span className="font">{fileNameSplit?.font}</span>
          <span className="delete">
            {fileName && (
              <ButtonTip title="删除">
                <IconButton
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  color="inherit"
                  onClick={handleDeleteFile}
                >
                  <DeleteForeverOutlinedIcon
                    style={{
                      fontSize: '20px',
                      color:
                        status === 'detail'
                          ? theme.palette.secondary.disabled
                          : theme.palette.primary.main,
                    }}
                  ></DeleteForeverOutlinedIcon>
                  {/* <SvgIconML
                    name="delete"
                    size={18}
                    fill={theme.palette.primary.main}
                  /> */}
                </IconButton>
              </ButtonTip>
            )}
          </span>
        </div>
      </div>
      <DialogDataML
        open={batchImportOpen}
        title={
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <span style={{ fontSize: '18px', fontWeight: 600 }}>批量上传</span>
            <IconButton
              aria-label="close"
              onClick={() => onCloseBatchImportDialog()}
            >
              <CloseIcon className="coupon-dialog-close-icon-style" />
            </IconButton>
          </Box>
        }
        content={batchImportContent()}
        onClose={onCloseBatchImportDialog}
        button={initButton()}
      />
    </UploadFileMLStyled>
  );
};

export default UploadFileML;
